;(function (global, factory) {
  typeof define === 'function' && define.amd ? define('MM/Models/ClientPortal/AccountSettings/RoleSelectionModel',['knockout', 'MM/Models/ClientPortal/AccountSettings/RoleLevel'], factory) :
  typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('knockout', 'MM/Models/ClientPortal/AccountSettings/RoleLevel')) :
  console && console.log('RoleSelectionModel works only in AMD')
}(this/* window */, function (ko, RoleLevel) { 
  function RoleSelectionModel(scope, roles, propertyTypes) {
    if(!scope) throw Error('Cannot create RoleSelectionModel without scope element.');

    this._loadDependencies();

    Object.defineProperty(this, 'scope', { writable: !1, configurable: !0, enumerable: !0, value: scope });
    Object.defineProperty(this, 'roles', { writable: !0, configurable: !0, enumerable: !0, value: roles || [] });
    Object.defineProperty(this, 'propertyTypes', { writable: !0, configurable: !0, enumerable: !0, value: propertyTypes || [] });
    Object.defineProperty(this, 'value', { configurable: !0, enumerable: !0, get: this._getModelValue.bind(this), set: this._setModelValue.bind(this) });

    Object.defineProperty(this, 'selectedRoles', { writable: !0, configurable: !0, enumerable: !0, value: ko.observableArray([]) });
    Object.defineProperty(this, 'onChangedHandlers', {writable: !1, configurable: !0, enumerable: !0, value: [] });

    this._setupEventHandlers();
    this._setupInstance();
  }

  RoleSelectionModel.prototype.addOnChangedHandler = function addOnChangedHandler(handlerFn, context) {
    if(!handlerFn || !handlerFn instanceof Function) throw Error('OnChange can be only a function.');

    // collect subscribers on who want to handle value change events
    this.onChangedHandlers.push(context === void 0 ? handlerFn : handlerFn.bind(context));
  }

  RoleSelectionModel.prototype.rolesSelectors = function() {
    // this is going to be the top level selection which should be visible always, even if user hasn't any selection (user logged in with GMail account)
    var selectionLevels = [new RoleLevel(null, !1, !1, '', this._getTopLevelRoles())];

    var level = null;
    // build next level based on the last added level
    while((level = this._buildNextLevel(selectionLevels.slice(-1)[0])) != null){
      selectionLevels.push(level);
    }

    return selectionLevels;
  }

  RoleSelectionModel.prototype._buildNextLevel = function _buildNextLevel(parentLevel) {
    // validate input argument for a proper dataset
    if(!parentLevel || !('Options' in parentLevel)) return null;

    var selectedParentOptions = parentLevel.Options.filter(function(roleOption){
      if(('TypeId' in roleOption) && ('TypeName' in roleOption)) {
        // skip hierarchy check if parent level is a Property Type selection level
        return !1;
      }

      // find if an option was selected, so we can dive deep into the hierarchy
      // ParentRoleId is a nullable integer, the top level roles will have null in their ParentRoleId. Other levels will have their ParentRoleId
      return ko.unwrap(this.selectedRoles).some(function(selectedOption) { 
        return selectedOption.RoleId === roleOption.RoleId && selectedOption.ParentRoleId === parentLevel.ParentRoleId;
      }, this /* context */);
    }, this /* context */);

    // no selected option was found on the level. Because of that we shouldn't build any child option
    if(!selectedParentOptions.length) {
      return null;
    }

    // if we have more than 1 role selected - someting wrong happen. Because we have only a single selection on a level.
    if(selectedParentOptions.length > 1) {
      console && console.log('Found more than 1 selection on a level: ', parentLevel, 'Found selections:', selectedParentOptions)
    }

    // take the first selection to build the next level
    var parentOption = selectedParentOptions[0];
    var level = new RoleLevel(parentOption.RoleId, parentOption.HasCustomText, parentOption.HasProductTypeSelection, parentOption.SubrolesTitle);
    if(parentOption.HasProductTypeSelection === !0) {
      var selectedRole = ko.unwrap(this.selectedRoles).filter(function(selectedRole) { return selectedRole.RoleId === parentOption.RoleId && selectedRole.ParentRoleId === parentLevel.ParentRoleId; }).pop();
      // if selected role marked as Product Type Selection, then we should push all available property tyles into the nextLevel options list (borrow array from a side hierarchy)
      level.Options = this.propertyTypes.slice();
      level.selectedOptions = ko.observableArray(((selectedRole ? ko.unwrap(selectedRole.ProductTypes) : null) || []).slice());
      level.selectedOptions.subscribe(this.saveSelection.bind(this, level));
      // notify parent components about change, even if change happen on Property Type selection which isn't an obserable Array on SelectedRoles property
      level.selectedOptions.subscribe(this._triggerOnChanged.bind(this));
      return level;
    } else if(parentOption.HasCustomText === !0) {
      var selectedRole = ko.unwrap(this.selectedRoles).filter(function(selectedRole) { return selectedRole.RoleId === parentOption.RoleId && selectedRole.ParentRoleId === parentLevel.ParentRoleId; }).pop();
      level.customText = ko.observable((selectedRole ? selectedRole.CustomText : null) || '');
      level.customText.subscribe(this.saveSelection.bind(this, level));
      // notify parent components about change, even if change happen on Property Type selection which isn't an obserable Array on SelectedRoles property
      level.customText.subscribe(this._triggerOnChanged.bind(this));
      return level;
    } else if (parentOption.Subroles instanceof Array && parentOption.Subroles.length){
      // if option has a subroles list, then we would pull list of subroles to the nextLevel options
      level.Options = parentOption.Subroles.slice();
      return level;
    }

    return null;
  }

  RoleSelectionModel.prototype.saveSelection = function saveSelection(level, selectedOption) {
    var oldSelection = ko.unwrap(this.selectedRoles);

    // this loop is looking for the previous selection, if user changed his opinion and decided to choose another role
    // but also this look needed to find role level above the All Property Types selection, since property types have to be added to the level above entity
    for(var selectionIndex = -1, index = 0; index < oldSelection.length; index++) {
      var selection = oldSelection[index];
      if( // look for previous selection on the same level
        selection.ParentRoleId === level.ParentRoleId 
        || (
          // if selection made on a child level to the role with ProductTypeSelection==true, then they should be modify the selection, instead of deleting it.
          !!level.HasProductTypeSelection && selection.RoleId === level.ParentRoleId
        )
        || (
          // if selection made on a child level to the role with CustomText==true, then we should modify the selection, instead of deleting it.
          !!level.HasCustomText && selection.RoleId === level.ParentRoleId
        )) {
        // preserve index
        selectionIndex = index;
        // stop, because we found selection index
        break;
      }
    }
    

    if(level.HasProductTypeSelection && (selectedOption instanceof Array)) {
      // pull the selected role to modify it.
      this.selectedRoles()[selectionIndex].ProductTypes = selectedOption.slice();
    } else if(level.HasCustomText && (typeof selectedOption === 'string' || selectedOption instanceof String)) {
      this.selectedRoles()[selectionIndex].CustomText = String(selectedOption);
    }  else {
      var oldSelectedRole = oldSelection[selectionIndex];
      // remove selection start from the level where user changed his opinion
      if(~selectionIndex) { 
        // ignore modification, if user did select the same option as it was before.
        // it helps not to drop children selection.
        if(oldSelectedRole.ParentRoleId === level.ParentRoleId && oldSelectedRole.RoleId === selectedOption.RoleId) { 
          return; 
        }
        // otherwise just drop it.
        this.selectedRoles.splice(selectionIndex);
      }
      // make a new role selection
        this.selectedRoles.push(this._makeSelectedRole(selectedOption.ExternalProfileRole, level.ParentRoleId, selectedOption.RoleId));
    }
  }

  RoleSelectionModel.prototype.getSelectionTitle = function getSelectionTitle(level, defaultTitle) {
    return level.LevelTitle || defaultTitle;
  }

  RoleSelectionModel.prototype.getSelectionText = function getSelectionText(roleLevel, defaultText) {
    var selectedOption = roleLevel.Options.filter(function(roleOption) {
      return ko.unwrap(this.selectedRoles).some(function(selectedOption) { 
        return (selectedOption.RoleId === roleOption.RoleId && selectedOption.ParentRoleId === roleLevel.ParentRoleId) 
              || (
                // if Property Type dropdown, then we should pull selected property types from the parent selected Role
                !!roleLevel.HasProductTypeSelection && selectedOption.RoleId === roleLevel.ParentRoleId && ~selectedOption.ProductTypes.indexOf(roleOption.TypeId)
              );
      });
    }, this).map(function(option) {
      // we can deal here with Role entities and with Property Type entities
      return option.RoleName || option.TypeName;
    }, this);

    // returns "RoleName", "RoleName (+99)", or return defaultText
    return selectedOption.length ? (selectedOption[0] + (selectedOption.length > 1 ? (' (+' + (selectedOption.length - 1) + ')') : '')) : null || defaultText;
  }

  RoleSelectionModel.prototype.getMultiselectConfig = function getMultiselectConfig(level, buttonId) {
    return { 
      numberDisplayed: 1,
      templates: {
        button: '<button id="' + buttonId + '" type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span></button>'
      },
      maxHeight: 250,
      onInitialized: this._propertyTypeOnInitHandler.bind(this, level)
    };
  }

  RoleSelectionModel.prototype.getOptionText = function getOptionText(entity) {
    return entity.RoleName || entity.TypeName;
  }

    RoleSelectionModel.prototype._makeSelectedRole = function _makeSelectedRole(externalProfileRole, parentRoleId, roleId) {
      return { 'ExternalProfileRole': externalProfileRole, 'ParentRoleId': parentRoleId, 'RoleId': roleId, 'ProductTypes': [], 'CustomText': null };
  }


  RoleSelectionModel.prototype._getModelValue = function _getModelValue(){
    return this.selectedRoles();
  }

  RoleSelectionModel.prototype._setModelValue = function _setModelValue(value) {
    if(!value || !(value instanceof Array)) return;

    var resortedValue = [];
    // it turns out Server Side will return roles array in a wront order, because of that we have to resort it manually here
    // the first step to find the top level role which has ParentRoleId == null
    for(var rolesToAdd = value.filter(function(role){ return role.ParentRoleId === null; }); 
        // at least one role found, otherwise just exit
        rolesToAdd.length; 
        // the next steps are going to be to find next level role based on the previous role.RoleId
        rolesToAdd = value.filter(function(role){ return role.ParentRoleId === resortedValue[resortedValue.length -1].RoleId; })) {
      // build role selection, the logic of sorting if in the for-loop definition above.
      // this isn't simpliest for-loop, but that is the fastest way I came up with to sort array in the order which I expect to receive from server side.
      resortedValue = resortedValue.concat(rolesToAdd);
    }

    this.selectedRoles.removeAll();
    resortedValue.forEach(function(role) { this.selectedRoles.push(Object.assign({}, role)); }, this);
  }

  RoleSelectionModel.prototype._propertyTypeOnInitHandler = function _propertyTypeOnInitHandler(level, $select, $container) {
    $container.find('>button.multiselect').on('change', this._updatePropertyTypeSelectionState.bind(this, level));
  }

  RoleSelectionModel.prototype._updatePropertyTypeSelectionState = function _updatePropertyTypeSelectionState(level, e) {
    var buttonEl = e.target;
    if(level.selectedOptions().length > 0) {
      buttonEl.classList.add('selection-complete');
    } else {
      buttonEl.classList.remove('selection-complete');
    }
  }

  RoleSelectionModel.prototype._loadDependencies = function _loadDependencies() {

  }

  RoleSelectionModel.prototype._getTopLevelRoles = function _getTopLevelRoles() {
    return this.roles;
  }

  RoleSelectionModel.prototype._setupEventHandlers = function _setupEventHandlers() {
    // notify about change
    this.selectedRoles.subscribe(this._triggerOnChanged.bind(this));
  }

  RoleSelectionModel.prototype._triggerOnChanged = function _triggerOnChanged() {
    this.onChangedHandlers.forEach(function(fn) { fn(this.value); }, this);
  }

  RoleSelectionModel.prototype._setupInstance = function _setupInstance() {
    // wrap it into knockout, so we will be able to re-render selections automatically by knockout
    this.rolesSelectors = ko.computed(this.rolesSelectors, this);

    // setup view model
    ko.applyBindings(this, this.scope);
  }

  return RoleSelectionModel;
}));
